import React, { useState } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { lighten, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Box from "@material-ui/core/Box";
import Collapse from "@material-ui/core/Collapse";
import IconButton from "@material-ui/core/IconButton";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import SearchBar from "material-ui-search-bar";

function descendingComparator(a, b, orderBy) {
  if (a[orderBy] === null) {
    return -1;
  } else if (b[orderBy] === null) {
    return 1;
  } else if (b[orderBy] < a[orderBy]) {
    return -1;
  } else if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  { id: "processDate", label: "Date" },
  { id: "batchId", label: "Order Id" },
  { id: "processedBy", label: "Processed By" },
];

function EnhancedTableHead(props) {
  const {
    classes,
    order,
    orderBy,
    onRequestSort,
    searchedObj,
    setSearched,
    setPage,
  } = props;

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  const handleInput = (searchVal, domain) => {
    setPage(0);
    setSearched({ searched: searchVal, domain: domain });
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell />
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align="center"
            padding={"normal"}
            sortDirection={orderBy === headCell.id ? order : false}
            style={{ fontFamily: "Overpass", fontSize: 20 }}
          >
            <div class="input-group" style={{ margin: "auto" }}>
              <SearchBar
                placeholder={headCell.label}
                value={
                  searchedObj.domain === headCell.id ? searchedObj.searched : ""
                }
                onChange={(searchVal) => handleInput(searchVal, headCell.id)}
                onCancelSearch={() => setSearched("")}
                className={classes.searchbar}
                style={{ width: "80%" }}
              />
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
              >
                {orderBy === headCell.id ? (
                  <span className={classes.visuallyHidden}>
                    {order === "desc"
                      ? "sorted descending"
                      : "sorted ascending"}
                  </span>
                ) : null}
              </TableSortLabel>
            </div>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    flex: "1 1 100%",
    margin: 40,
  },
}));

const EnhancedTableToolbar = (props) => {
  const classes = useToolbarStyles();
  const { numSelected } = props;
  return (
    <Toolbar
      className={clsx(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      <Typography
        className={classes.title}
        variant="h6"
        id="tableTitle"
        component="div"
      >
        Review Order History
      </Typography>
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  searchbar: {
    width: "200px",
    height: "40px",
  },
}));

const getDateFormat = (date) => {
  if (date == null) return;
  var newDate = date.split("T")[0];
  var dateArray = newDate.split("-");
  var year = dateArray[0].substring(2);
  var month = dateArray[1];
  var day = dateArray[2];
  var fullTime = date.split("T")[1].split(".")[0];
  var hour = fullTime.substring(0, 2);
  var finalTime;
  if (parseInt(hour) > 12) {
    if (parseInt(hour) > 21) {
      finalTime = hour - 12 + fullTime.substring(2, 5);
    } else {
      finalTime = "0" + (hour - 12) + fullTime.substring(2, 5);
    }
    finalTime += " PM";
  } else {
    finalTime = hour + fullTime.substring(2, 5);
    finalTime += " AM";
  }
  var myDate = `${month}/${day}/${year} - ${finalTime}`;
  return myDate;
};

function CollapsedRows(props) {
  const { row, index } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow
        style={{ height: "60px", background: index % 2 ? "#f8f8f8" : "white" }}
      >
        <TableCell style={{ width: "4%", borderBottom: "none" }}>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell
          align="center"
          style={{ width: "32%", fontFamily: "Overpass", borderBottom: "none" }}
        >
          {getDateFormat(row.processDate)}
        </TableCell>
        <TableCell
          align="center"
          style={{ width: "32%", fontFamily: "Overpass", borderBottom: "none" }}
        >
          {row.batchId}
        </TableCell>
        <TableCell
          align="center"
          style={{ width: "32%", fontFamily: "Overpass", borderBottom: "none" }}
        >
          {row.processedBy}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Typography variant="h6" gutterBottom component="div">
                Order History Status
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>GMID/GMIN</TableCell>
                    <TableCell>Status</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row.audits.map((r, i) => {
                    return (
                      <TableRow>
                        <TableCell
                          align="left"
                          style={{
                            fontFamily: "Overpass",
                            width: "20%",
                            background: i % 2 == 0 ? "#f8f8f8" : null,
                          }}
                        >
                          {r.gmid}
                        </TableCell>
                        <TableCell
                          align="left"
                          style={{
                            fontFamily: "Overpass",
                            borderLeft: "1px solid rgba(224, 224, 224, 1)",
                            background: i % 2 == 0 ? "#f8f8f8" : null,
                          }}
                        >
                          {r.status}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

const ReviewOrderHistoryTable = ({ data: orderHistory }) => {
  const classes = useStyles();
  const [order, setOrder] = React.useState("desc");
  const [orderBy, setOrderBy] = React.useState("processDate");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [rows, setRows] = useState(orderHistory);
  const [searchedObj, setSearched] = useState({ searched: "", domain: "" });

  const handleFilter = () => {
    const filteredRows = orderHistory.filter((row) => {
      if (searchedObj.domain === "processDate") {
        if (
          searchedObj.searched.length > 0 &&
          getDateFormat(row.processDate) == null
        )
          return false;
        else if (getDateFormat(row.processDate) != null)
          return getDateFormat(row.processDate)
            .toString()
            .toLowerCase()
            .includes(searchedObj.searched.toLowerCase());
      }
      if (searchedObj.domain === "batchId") {
        if (searchedObj.searched.length > 0 && row.batchId == null)
          return false;
        else if (row.batchId != null)
          return row.batchId
            .toString()
            .toLowerCase()
            .includes(searchedObj.searched.toLowerCase());
      }
      if (searchedObj.domain === "processedBy") {
        if (searchedObj.searched.length > 0 && row.processedBy == null)
          return false;
        else if (row.processedBy != null)
          return row.processedBy
            .toString()
            .toLowerCase()
            .includes(searchedObj.searched.toLowerCase());
      } else return rows;
    });
    return filteredRows;
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows =
    rowsPerPage -
    Math.min(rowsPerPage, handleFilter().length - page * rowsPerPage);

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <EnhancedTableToolbar />
        <TableContainer>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            size={"medium"}
            aria-label="enhanced table"
          >
            <EnhancedTableHead
              classes={classes}
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              handleSearch={handleFilter}
              searchedObj={searchedObj}
              setSearched={setSearched}
              setPage={setPage}
            />

            <TableBody>
              {stableSort(handleFilter(), getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  return <CollapsedRows row={row} index={index} />;
                })}
              {emptyRows > 0 && handleFilter().length >= rowsPerPage && (
                <TableRow style={{ height: 60 * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 50, 100]}
          component="div"
          count={handleFilter().length}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangeRowsPerPage={handleChangeRowsPerPage} // Material v < 4
          onRowsPerPageChange={handleChangeRowsPerPage} // Material v > 4
          onPageChange={handleChangePage} // Material v > 4
          onChangePage={handleChangePage} // Material v < 4
        />
      </Paper>
    </div>
  );
};

export default ReviewOrderHistoryTable;
